(() => {
  if (window.WohnjoyWishlist) return;
  const key = 'glozin__wishlist-items';
  const variantKey = 'wohnjoy__wishlist-variants';
  const read = (name, fallback) => {
    try { return JSON.parse(localStorage.getItem(name)) ?? fallback; } catch { return fallback; }
  };
  const ids = values => Array.isArray(values) ? [...new Set(values.map(String).filter(value => /^\d+$/.test(value)))] : [];
  const readIds = () => ids(read(key, []));
  const variants = () => {
    const value = read(variantKey, {});
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  };
  const sync = list => {
    document.querySelectorAll('.wishlist-count').forEach(node => { node.textContent = String(list.length); });
    document.querySelectorAll('button-wishlist[data-product-id]').forEach(node => {
      const active = list.includes(node.dataset.productId);
      node.classList.toggle('active', active);
      node.setAttribute('aria-pressed', String(active));
      if (node.classList.contains('wj-card-save')) node.setAttribute('aria-label', active ? (node.dataset.action === 'redirect' ? node.dataset.tooltipRedirect : node.dataset.tooltipRemove) : node.dataset.tooltipAdd);
      const tooltip = node.querySelector('.tooltip-content');
      if (tooltip) tooltip.textContent = active ? (node.dataset.action === 'redirect' ? node.dataset.tooltipRedirect : node.dataset.tooltipRemove) || tooltip.textContent : node.dataset.tooltipAdd || tooltip.textContent;
    });
  };
  const setIds = (values, source = '') => {
    const list = ids(values);
    try { localStorage.setItem(key, JSON.stringify(list)); } catch { return false; }
    sync(list);
    document.dispatchEvent(new CustomEvent('wohnjoy:wishlist-change', { detail: { ids: list, source } }));
    return true;
  };
  const remember = (productId, variantId) => {
    if (!/^\d+$/.test(String(productId)) || !/^\d+$/.test(String(variantId))) return false;
    const saved = variants();
    saved[String(productId)] = String(variantId);
    try { localStorage.setItem(variantKey, JSON.stringify(saved)); } catch { return false; }
    return true;
  };
  const rememberFrom = (button, productId) => {
    const card = button.closest('.product-item,.product-detail__information,.sticky-add-cart,.miniture-mega-product');
    const variant = card?.querySelector('input[name="id"]')?.value || card?.querySelector('[data-wj-variant][aria-pressed="true"]')?.dataset.variantId;
    if (variant) remember(productId, variant);
  };
  window.WohnjoyWishlist = { readIds, setIds, variants, remember, rememberFrom, sync };
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== variantKey) return;
    const list = readIds();
    sync(list);
    document.dispatchEvent(new CustomEvent('wohnjoy:wishlist-change', { detail: { ids: list, source: 'storage' } }));
  });
})();
